import * as z from "zod/v4";
import { CatalogProductWithInventorySchema_ } from "./get-marketplace-products";

/** Option definition for a product (e.g., "Size" with values ["S", "M", "L"]) */
const ProductOptionDefinitionSchema_ = z.object({
  name: z.string(),
  values: z.array(z.string()),
});
export const ProductOptionDefinitionSchema: z.ZodType<ProductOptionDefinition> =
  ProductOptionDefinitionSchema_;
export interface ProductOptionDefinition
  extends z.infer<typeof ProductOptionDefinitionSchema_> {}

const PopulatedCatalogProductSchema_ =
  CatalogProductWithInventorySchema_.extend({
    options: z.array(ProductOptionDefinitionSchema),
  });

export const PopulatedCatalogProductSchema: z.ZodType<PopulatedCatalogProduct> =
  PopulatedCatalogProductSchema_;
export interface PopulatedCatalogProduct
  extends z.infer<typeof PopulatedCatalogProductSchema_> {}

const PopulatedVariantSchema_ = z.object({
  _id: z.string(),
  optionValues: z.array(z.string()),
  images: z.array(z.string()),
  price: z.number().nullish(),
  msrp: z.number().nullish(),
  barcode: z.string().nullish(),
  minQuantity: z.number().min(0).default(0),
  available: z.number().min(0),
});
export const PopulatedVariantSchema: z.ZodType<PopulatedVariant> =
  PopulatedVariantSchema_;
export interface PopulatedVariant
  extends z.infer<typeof PopulatedVariantSchema_> {}

const PopulatedCatalogProductWithVariantsSchema_ =
  PopulatedCatalogProductSchema_.omit({ variants: true }).extend({
    variants: z.array(PopulatedVariantSchema),
  });

export const PopulatedCatalogProductWithVariantsSchema: z.ZodType<PopulatedCatalogProductWithVariants> =
  PopulatedCatalogProductWithVariantsSchema_;
export interface PopulatedCatalogProductWithVariants
  extends z.infer<typeof PopulatedCatalogProductWithVariantsSchema_> {}

export const getProductDetails = {
  name: "getProductDetails" as const,
  input: z.object({ listingId: z.string() }),
  output: PopulatedCatalogProductWithVariantsSchema,
};
